import { render, staticRenderFns } from "./HousingHeatmap.vue?vue&type=template&id=5d3c83c8"
import script from "./HousingHeatmap.vue?vue&type=script&lang=js"
export * from "./HousingHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports